import { IAgent, Presenter, VideoType } from '@d-id/types';
import { runInAction } from 'mobx';

export const initializePresenter = (presenter: Presenter, agent: IAgent | null, agentEditorStore: any) => {
    if (!presenter) return;

    runInAction(() => {
        agentEditorStore.setSelectedPresenter(presenter.id);
        if (agent?.presenter?.type === VideoType.TALK && agent?.presenter?.thumbnail?.includes('merged-bg-color')) {
            agentEditorStore.setPresenterBackgroundSourceUrl(agent?.presenter?.source_url || agent?.presenter?.thumbnail);
            agentEditorStore.setPresenterBackgroundThumbnailUrl(agent?.presenter?.thumbnail);
        }

        if (agent?.presenter?.type === VideoType.CLIP) {
            agentEditorStore.setPresenterBackgroundSourceUrl(agent?.presenter?.background?.source_url || '');
            agentEditorStore.setPresenterBackgroundColor(agent?.presenter?.background?.color || '');
            agentEditorStore.setPresenterBackgroundThumbnailUrl(agent?.presenter?.thumbnail);
        }

        agentEditorStore.setInitAgentState((prevState: any) => ({
            ...prevState,
            presenter_id: presenter.id,
        }));
    });
};
